export const ROLE_ENCRYPT = [
  { role: 'admin-school', encrypted: 'x1lvqqaSwFZNnczu' },
  { role: 'accountant', encrypted: '5Ukos7SRcWRqL6E3' },
  { role: 'teacher', encrypted: '7jTGb1vpA77qluN+' },
];

export enum ROLE {
  ADMIN = 'x1lvqqaSwFZNnczu',
  ACCOUNTANT = '5Ukos7SRcWRqL6E3',
  TEACHER = '7jTGb1vpA77qluN+',
}
export const checkRole = (expectRole: ROLE): boolean => {
  return localStorage.getItem('role') === expectRole;
};